import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0284156e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=0284156e&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=0284156e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284156e",
  null
  
)

export default component.exports